import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

const initialState = {
  notifPanel: false,
  searchPanel: false,
  notifications: [],
  notificationSetup: []
}

const getters = {
  notifPanel: state => state.notifPanel,
  searchPanel: state => state.searchPanel,
  notifications: state => state.notifications,
  notificationSetup: state => state.notificationSetup
}

const mutations = {
  notifPanel: (state, value) => {
    state.notifPanel = value
  },
  searchPanel: (state, value) => {
    state.searchPanel = value
  },
  notifications: (state, notifications) => {
    state.notifications = notifications
  },
  closePanel: (state) => {
    state.notifPanel = false
    state.searchPanel = false
  },
  approveNotif: (state, idNotif) => {
    const index = state.notifications.findIndex(notif => notif.id === idNotif)
    state.notifications[index].action = 'approved'
  },
  declineNotif: (state, idNotif) => {
    const index = state.notifications.findIndex(notif => notif.id === idNotif)
    state.notifications[index].action = 'declined'
  },
  markNotificationIsRead: (state, notificationId) => {
    const index = state.notifications.findIndex(notif => notif.id === notificationId)
    state.notifications[index].isRead = true
  },
  markAllNotificationsAreRead: (state) => {
    state.notifications.forEach(element => {
      element.isRead = true
    })
  },
  notificationSetup: (state, notificationSetup) => {
    state.notificationSetup = notificationSetup
  },
  updateNotificationSetup: (state, payload) => {
    const index = state.notificationSetup.findIndex(notif => notif.type === payload.type)
    state.notificationSetup[index].web = payload.web
    state.notificationSetup[index].email = payload.email
  },
  updateAllWebNotification: (state) => {
    state.notificationSetup.forEach(notif => {
      notif.web = true
    })
  },
  updateNoWebNotification: (state) => {
    state.notificationSetup.forEach(notif => {
      notif.web = false
    })
  },
  updateAllEmailNotification: (state) => {
    state.notificationSetup.forEach(notif => {
      notif.email = true
    })
  },
  updateNoEmailNotification: (state) => {
    state.notificationSetup.forEach(notif => {
      notif.email = false
    })
  },
  deleteNotification: (state, notifId) => {
    const index = state.notifications.findIndex(notif => notif.id === notifId)
    state.notifications.splice(index, 1)
  },
  deleteAllNotifications: (state) => {
    state.notifications = []
  }
}

const actions = {
  async showHidePanel ({ commit, state }, panelType) {
    if (panelType === 'NOTIF') {
      if (!state.notifPanel) {
        let notifications = await axios.get(`${config.getRootApi()}/notification/`)
        commit('notifications', notifications.data)
      }
      commit('searchPanel', false)
      commit('notifPanel', !state.notifPanel)
    } else if (panelType === 'SEARCH') {
      commit('notifPanel', false)
      commit('searchPanel', !state.searchPanel)
    }
  },
  async markNotificationIsRead ({ commit }, notificationId) {
    await axios.post(`${config.getRootApi()}/notification/${notificationId}/notificationRead`, null)
    commit('markNotificationIsRead', notificationId)
  },
  async markAllNotificationsAreRead ({ commit, state }, notifId) {
    await axios.post(`${config.getRootApi()}/notification/${notifId}/allnotificationsRead`, null)
    commit('markAllNotificationsAreRead')
  },
  async getNotificationSetup ({ commit }) {
    const notificationSetup = await axios.get(`${config.getRootApi()}/notification/getNotificationSetup`)
    commit('notificationSetup', notificationSetup.data)
  },
  async updateNotificationSetup ({ commit }, { type, web, email }) {
    await axios.post(`${config.getRootApi()}/notification/updateNotificationSetup`, { type: type, web: web, email: email })
    commit('updateNotificationSetup', { type: type, web: web, email: email })
  },
  async updateAllWebNotification ({ commit }) {
    await axios.post(`${config.getRootApi()}/notification/updateAllWebNotification/`, null)
    commit('updateAllWebNotification')
  },
  async updateNoWebNotification ({ commit }) {
    await axios.post(`${config.getRootApi()}/notification/updateNoWebNotification/`, null)
    commit('updateNoWebNotification')
  },
  async updateAllEmailNotification ({ commit }) {
    await axios.post(`${config.getRootApi()}/notification/updateAllEmailNotification/`, null)
    commit('updateAllEmailNotification')
  },
  async updateNoEmailNotification ({ commit }) {
    await axios.post(`${config.getRootApi()}/notification/updateNoEmailNotification/`, null)
    commit('updateNoEmailNotification')
  },
  async deleteNotification ({ commit }, notifId) {
    await axios.delete(`${config.getRootApi()}/notification/${notifId}`)
    commit('deleteNotification', notifId)
  },
  async deleteAllNotifications ({ commit }) {
    await axios.post(`${config.getRootApi()}/notification/deleteAllNotifications`, null)
    commit('deleteAllNotifications')
  }
}

export default {
  state: initialState,
  getters,
  mutations,
  actions
}
